import React, { useState } from "react";
import { Link as ScrollLink } from "react-scroll";
import { useLanguage } from "../LanguageContext"; // ✅ Import context
import logo from "../assets/images/Dinik.png";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(!menuOpen);

  const { language, setLanguage } = useLanguage(); // ✅ Use context

  const handleLanguageChange = (e) => {
    setLanguage(e.target.value);
  };

  const labels = {
    en: {
      home: "Home",
      services: "Services",
      portfolio: "Portfolio",
      pricing: "Pricing",
      contact: "Contact",
    },
    id: {
      home: "Beranda",
      services: "Layanan",
      portfolio: "Portofolio",
      pricing: "Harga",
      contact: "Kontak",
    },
  };

  const t = labels[language]; // shortcut

  return (
    <header className="bg-[#ffe7c7] text-black shadow-md fixed top-0 w-full z-50">
      <nav className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
        {/* Logo */}
        <ScrollLink to="hero" smooth={true} duration={500} offset={-70} className="cursor-pointer">
          <img src={logo} alt="DinikDelavega Logo" className="h-14 w-auto md:h-12" />
        </ScrollLink>

        {/* Language Dropdown */}
        <select
          value={language}
          onChange={handleLanguageChange}
          className="ml-4 border border-gray-300 text-sm px-2 py-1 rounded"
        >
          <option value="en">English</option>
          <option value="id">Bahasa</option>
        </select>

        {/* Hamburger Menu (Mobile) */}
        <div className="md:hidden">
          <button onClick={toggleMenu}>
            <svg className="w-6 h-6" fill="none" stroke="black" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>

        {/* Full Menu (Desktop) */}
        <ul className="hidden md:flex space-x-6 font-semibold">
          <li><ScrollLink to="hero" smooth={true} duration={500} className="cursor-pointer hover:underline">{t.home}</ScrollLink></li>
          <li><ScrollLink to="services" smooth={true} duration={500} className="cursor-pointer hover:underline">{t.services}</ScrollLink></li>
          <li><ScrollLink to="portfolio" smooth={true} duration={500} className="cursor-pointer hover:underline">{t.portfolio}</ScrollLink></li>
          <li><ScrollLink to="pricing" smooth={true} duration={500} className="cursor-pointer hover:underline">{t.pricing}</ScrollLink></li>
          <li><ScrollLink to="contact" smooth={true} duration={500} className="cursor-pointer hover:underline">{t.contact}</ScrollLink></li>
        </ul>
      </nav>

      {/* Dropdown Menu (Mobile) */}
      {menuOpen && (
        <ul className="md:hidden bg-[#ffe7c7] text-black px-4 py-2 space-y-2 shadow-md">
          <li><ScrollLink to="hero" smooth={true} duration={500} onClick={toggleMenu}>{t.home}</ScrollLink></li>
          <li><ScrollLink to="services" smooth={true} duration={500} onClick={toggleMenu}>{t.services}</ScrollLink></li>
          <li><ScrollLink to="portfolio" smooth={true} duration={500} onClick={toggleMenu}>{t.portfolio}</ScrollLink></li>
          <li><ScrollLink to="pricing" smooth={true} duration={500} onClick={toggleMenu}>{t.pricing}</ScrollLink></li>
          <li><ScrollLink to="contact" smooth={true} duration={500} onClick={toggleMenu}>{t.contact}</ScrollLink></li>
        </ul>
      )}
    </header>
  );
};

export default Navbar;
